(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
  };
  const isHome = !!$("#rozpal-home, .hero");
  const narrow = matchMedia("(max-width: 560px)");
  const addLabel = () => (narrow.matches ? "Do koszyka" : "Dodaj do koszyka");

  // ---------- money ----------
  const money = (cents) => {
    const v = cents / 100;
    return `${Number.isInteger(v) ? v : v.toFixed(2).replace(".", ",")} zł`;
  };

  // ---------- media (flat theme asset names) ----------
  const A = (name) => RJ.assets + name;
  const lifeImg = (s, i = 1) => A(`rj-${s.slug}-${i}.jpg`);
  const prodImg = (s, name) => A(`rj-p-${s.slug}_${name}.jpg`);
  const poster = (s) => A(`rj-poster-${s.slug}.jpg`);
  const video = (s) => A(`rj-v-${s.slug}.mp4`);
  // where to anchor the crop of a picture without a lifestyle shoot (e.g. the candle at the top of Rausz)
  const moodPos = (s) => (!s.life && s.hoverPos ? ` style="object-position:${s.hoverPos}"` : "");
  const moodImg = (s) => (s.life ? lifeImg(s, 1) : A(s.hover));
  // studio photo numbers for a form + colour; tunel lists [single, duo on tray], so the zestaw shows the duo first
  const formShots = (s, formKey, colorKey) => {
    const m = PRODMAP[s.slug][colorKey];
    return formKey === "ellipsa" ? m.ellipsa : formKey === "zestaw" ? [...m.tunel].reverse() : m.tunel;
  };

  // ---------- live catalog: join the story copy with Shopify products ----------
  const norm = (t) => String(t).normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ł/gi, "l").toUpperCase().replace(/[^A-Z0-9]+/g, " ").trim();
  const COLOR_NAMES = COLORS.map((c) => norm(c.name));
  const colorIndexOf = (values) => values.map(norm).map((v) => COLOR_NAMES.indexOf(v)).find((i) => i >= 0) ?? -1;
  const zestawEntry = Object.entries(RJ.products).find(([h, p]) => h.includes("zestaw") || norm(p.title).startsWith("ZESTAW"));
  const ZESTAW_PRODUCT = zestawEntry ? { handle: zestawEntry[0], ...zestawEntry[1] } : null;

  const SCENTS_LIVE = SCENTS.filter((s) => s.limited || RJ.products[s.handle]).map((s) => ({ ...s, product: RJ.products[s.handle] || null }));
  const bySlug = Object.fromEntries(SCENTS_LIVE.map((s) => [s.slug, s]));
  const byHandle = Object.fromEntries(SCENTS_LIVE.filter((s) => s.handle).map((s) => [s.handle, s]));

  // the Shopify variant for a scent in a form ("tunel" | "ellipsa" | "zestaw") and colour index
  function variantFor(s, formKey, ci) {
    const color = COLOR_NAMES[ci];
    if (formKey === "zestaw") {
      if (!ZESTAW_PRODUCT) return null;
      const name = norm(s.name);
      return ZESTAW_PRODUCT.variants.find((v) => v.options.map(norm).includes(color) && v.options.map(norm).some((o) => o === name || o.startsWith(name + " "))) || null;
    }
    if (!s.product) return null;
    const lead = formKey === "tunel" ? "TUNEL" : "ELLIPSA";
    return s.product.variants.find((v) => v.options.map(norm).includes(color) && v.options.map(norm).some((o) => o.startsWith(lead))) || null;
  }
  const formsOf = (s) => FORMS.filter((f) => COLORS.some((_, ci) => variantFor(s, f.key, ci)));
  const fromPrice = (s) => {
    const prices = ["tunel", "ellipsa"].flatMap((k) => COLORS.map((_, ci) => variantFor(s, k, ci))).filter(Boolean).map((v) => v.price);
    return prices.length ? Math.min(...prices) : null;
  };
  const fromLabel = (s) => (s.limited ? "wkrótce" : fromPrice(s) != null ? `od ${money(fromPrice(s))}` : "");

  // ---------- cart (Shopify AJAX cart) ----------
  const api = {
    req: (url, body) => fetch(url, { method: body ? "POST" : "GET", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: body && JSON.stringify(body) })
      .then((r) => r.json().then((j) => (r.ok ? j : Promise.reject(j)))),
    get: () => api.req(`${RJ.routes.cart}.js`),
    add: (items) => api.req(`${RJ.routes.cartAdd}.js`, { items }),
    change: (key, quantity) => api.req(`${RJ.routes.cartChange}.js`, { id: key, quantity }),
  };
  let cart = null;

  // what a cart line is in Rozpal Ją terms: scent, form key, colour index
  function describe(item) {
    const values = (item.options_with_values || []).map((o) => o.value);
    const ci = colorIndexOf(values);
    if (ZESTAW_PRODUCT && item.handle === ZESTAW_PRODUCT.handle) {
      const s = SCENTS_LIVE.find((x) => values.map(norm).some((v) => v === norm(x.name) || v.startsWith(norm(x.name) + " ")));
      return { s, form: "zestaw", ci };
    }
    const s = byHandle[item.handle];
    const form = values.map(norm).some((v) => v.startsWith("ELLIPSA")) ? "ellipsa" : values.map(norm).some((v) => v.startsWith("TUNEL")) ? "tunel" : null;
    return { s, form, ci };
  }

  function renderCart() {
    if (!cart) return;
    const c = $("#cartCount");
    if (c) { c.textContent = cart.item_count; c.classList.toggle("has", cart.item_count > 0); }
    if (!$("#cartItems")) return;
    const t = cart.total_price, left = Math.max(0, RJ.freeShipping - t);
    $("#ship").innerHTML = (left ? `Jeszcze <b>${money(left)}</b> do darmowej wysyłki` : `<b>Masz darmową wysyłkę ✦</b>`) + `<div class="bar"><i style="width:${Math.min(100, (t / RJ.freeShipping) * 100)}%"></i></div>`;
    $("#cartItems").innerHTML = cart.items.length ? cart.items.map((it, i) => {
      const { s, form, ci } = describe(it);
      const known = s && form && ci >= 0;
      const f = known ? FORMS.find((x) => x.key === form) : null;
      const img = known ? prodImg(s, `${COLORS[ci].key}-${formShots(s, form, COLORS[ci].key)[0]}`) : (it.image || "");
      const desc = known
        ? (form === "zestaw" ? `Zestaw: 2 × Tunel 180 g + podstawka · ${COLORS[ci].name}` : `${f.name} ${f.weight} · ${COLORS[ci].name}`)
        : (it.variant_title || "");
      // a single tunel can become a zestaw (2nd candle + tray); two tunels are cheaper as a zestaw
      let up = "";
      const z = known && form === "tunel" ? variantFor(s, "zestaw", ci) : null;
      if (z && z.available) {
        const unit = it.final_price;
        up = it.quantity >= 2
          ? `<button class="upsell" data-up="${i}">Zamień 2 szt. w zestaw z podstawką: <b>${money(z.price)}</b> zamiast ${money(2 * unit)}</button>`
          : `<button class="upsell" data-up="${i}">Dodaj drugą i podstawkę: zestaw za <b>${money(z.price)}</b> (+${money(z.price - unit)})</button>`;
      }
      const name = known ? s.name : it.product_title;
      return `<div class="cart-item">
        ${img ? `<img src="${img}" alt="">` : "<span></span>"}
        <div><h4>${name}</h4><small>${desc}</small>
          <div class="qty"><button data-i="${i}" data-d="-1" aria-label="Mniej">−</button><span>${it.quantity}</span><button data-i="${i}" data-d="1" aria-label="Więcej">+</button></div></div>
        <div><div class="pr">${money(it.final_line_price)}</div><button class="rm" data-rm="${i}">usuń</button></div>
        ${up}
      </div>`;
    }).join("") : `<p class="cart-empty">Twój koszyk jeszcze nie pachnie.<br><a href="${RJ.routes.root}#moment" data-close>Znajdź swój zapach →</a></p>`;
    $("#cartTotal").textContent = money(t);
    $("#checkoutBtn").classList.toggle("disabled", !cart.items.length);
  }
  const refreshCart = () => api.get().then((c) => { cart = c; renderCart(); return c; });
  const bump = () => { const c = $("#cartCount"); if (!c) return; c.classList.remove("bump"); void c.offsetWidth; c.classList.add("bump"); };
  function openCart() { renderCart(); $("#cart").hidden = false; document.body.classList.add("locked"); }
  async function addVariant(id, quantity, label) {
    try {
      await api.add([{ id, quantity }]);
      await refreshCart(); bump();
      if (label) toast(`${label} czeka w koszyku ✦`);
      return true;
    } catch (e) {
      toast(e && e.description ? e.description : "Nie udało się dodać do koszyka");
      return false;
    }
  }

  $("#cartBtn")?.addEventListener("click", (e) => { e.preventDefault(); openCart(); });
  $("#checkoutBtn")?.addEventListener("click", (e) => { if (!cart || !cart.items.length) e.preventDefault(); });
  $("#cartItems")?.addEventListener("click", async (e) => {
    const q = e.target.closest("[data-d]"), r = e.target.closest("[data-rm]"), u = e.target.closest("[data-up]");
    try {
      if (q) { const it = cart.items[q.dataset.i]; cart = await api.change(it.key, Math.max(0, it.quantity + Number(q.dataset.d))); renderCart(); }
      if (r) { cart = await api.change(cart.items[r.dataset.rm].key, 0); renderCart(); }
      if (u) {
        const it = cart.items[u.dataset.up], { s, ci } = describe(it), z = variantFor(s, "zestaw", ci);
        await api.change(it.key, it.quantity - Math.min(2, it.quantity));
        await api.add([{ id: z.id, quantity: 1 }]);
        await refreshCart(); bump();
        toast("Zestaw z podstawką gotowy ✦");
      }
    } catch (err) { toast(err && err.description ? err.description : "Coś poszło nie tak, spróbuj jeszcze raz"); refreshCart(); }
  });
  refreshCart();

  // ---------- product view (dialog on the homepage, inline on the product page) ----------
  function mountPdp(root, opts = {}) {
    const P = (k) => root.querySelector(`[data-pdp="${k}"]`);
    let s = null, forms = [], sel = { form: 0, color: 1, qty: 1, media: 0 };

    const galleryFor = () => {
      const items = [];
      for (let i = 1; i <= s.life; i++) items.push({ type: "img", src: lifeImg(s, i) });
      if (!s.life && s.hover) items.push({ type: "img", src: A(s.hover) });
      items.splice(Math.min(1, items.length), 0, { type: "video", src: video(s), poster: poster(s) });
      const form = forms[sel.form].key, color = COLORS[sel.color].key;
      const pick = formShots(s, form, color).map((n) => ({ type: "img", src: prodImg(s, `${color}-${n}`), sel: true }));
      pick.push({ type: "img", src: prodImg(s, form === "ellipsa" ? "duza" : "mala"), sel: true });
      return items.concat(pick);
    };
    const renderThumbs = () => {
      P("thumbs").innerHTML = galleryFor().map((m) => `<button class="${m.type === "video" ? "play" : ""}"><img src="${m.type === "video" ? m.poster : m.src}" alt="" loading="lazy"></button>`).join("");
    };
    const showMedia = (i) => {
      const g = galleryFor();
      sel.media = (i + g.length) % g.length;
      const m = g[sel.media];
      P("main").innerHTML = m.type === "video"
        ? `<video src="${m.src}" poster="${m.poster}" autoplay muted loop playsinline controls></video>`
        : `<img src="${m.src}" alt="Świeca ${s.name}">`;
      $$("button", P("thumbs")).forEach((b, j) => b.classList.toggle("on", j === sel.media));
      $$("button", P("thumbs"))[sel.media]?.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
    };
    const showSelection = () => { renderThumbs(); showMedia(galleryFor().findIndex((m) => m.sel)); };
    const current = () => (s.limited ? null : variantFor(s, forms[sel.form].key, sel.color));
    const render = () => {
      $$(".opt-form", root).forEach((b, i) => b.setAttribute("aria-pressed", String(i === sel.form)));
      $$(".swatch", root).forEach((b, i) => {
        b.setAttribute("aria-pressed", String(i === sel.color));
        b.classList.toggle("off", !s.limited && !variantFor(s, forms[sel.form].key, i));
      });
      P("color-name").textContent = COLORS[sel.color].name;
      P("qty").textContent = sel.qty;
      const add = P("add"), v = current();
      add.disabled = !v || !v.available;
      add.textContent = s.limited ? "Edycja limitowana — wkrótce" : !v ? "Niedostępne w tym wariancie" : !v.available ? "Chwilowo wyprzedane" : `${addLabel()} · ${money(v.price * sel.qty)}`;
    };

    function open(slug, preselect) {
      s = bySlug[slug];
      forms = s.limited ? FORMS.slice(0, 2) : formsOf(s);
      sel = { form: 0, color: 1, qty: 1, media: 0 };
      if (preselect) Object.assign(sel, preselect);
      if (!s.limited && !variantFor(s, forms[sel.form].key, sel.color)) sel.color = COLORS.findIndex((_, ci) => variantFor(s, forms[sel.form].key, ci));
      P("tag").textContent = s.tagline;
      P("name").textContent = s.name;
      P("line").textContent = s.line;
      P("story").textContent = s.story;
      const labels = s.notes.length === 3 ? ["Otwarcie", "Serce", "Baza"] : s.notes.length === 2 ? ["Otwarcie", "Baza"] : ["Nuta"];
      P("notes").innerHTML = s.notes.map((n, i) => `<div><small>${labels[i]}</small><span>${n}</span></div>`).join("");
      const moments = MOODS.filter((m) => m.picks.includes(s.slug)).map((m) => m.label);
      P("moments").innerHTML = moments.length ? `<small>Idealna na</small>${moments.map((m) => `<span class="note">${m}</span>`).join("")}` : "";
      P("forms").innerHTML = forms.map((f) => {
        const vs = COLORS.map((_, ci) => variantFor(s, f.key, ci)).filter(Boolean);
        const price = vs.length ? Math.min(...vs.map((v) => v.price)) : null;
        const tun = COLORS.map((_, ci) => variantFor(s, "tunel", ci)).filter(Boolean);
        const was = f.key === "zestaw" && tun.length ? 2 * Math.min(...tun.map((v) => v.price)) : null;
        const save = was && price && was > price ? `<i class="save">−${money(was - price)}</i>` : "";
        return `<button class="opt-form${save ? " deal" : ""}">${save}<b>${f.name} <small>${f.weight}</small></b><span>${f.burn} płomienia · ${f.wicks}</span><em>${save ? `<s>${money(was)}</s> ` : ""}${price != null ? money(price) : ""}</em></button>`;
      }).join("");
      P("colors").innerHTML = COLORS.map((c) => `<button class="swatch ${c.key}" aria-label="${c.name}" title="${c.name}"></button>`).join("");
      renderThumbs(); showMedia(preselect ? galleryFor().findIndex((m) => m.sel) : 0); render();
    }

    P("thumbs").addEventListener("click", (e) => { const b = e.target.closest("button"); if (b) showMedia($$("button", P("thumbs")).indexOf(b)); });
    P("forms").addEventListener("click", (e) => {
      const b = e.target.closest(".opt-form"); if (!b) return;
      sel.form = $$(".opt-form", root).indexOf(b);
      if (!variantFor(s, forms[sel.form].key, sel.color)) sel.color = Math.max(0, COLORS.findIndex((_, ci) => variantFor(s, forms[sel.form].key, ci)));
      render(); showSelection();
    });
    P("colors").addEventListener("click", (e) => {
      const b = e.target.closest(".swatch"); if (!b) return;
      sel.color = $$(".swatch", root).indexOf(b); render(); showSelection();
    });
    $(".pdp-buy .qty", root).addEventListener("click", (e) => { const b = e.target.closest("[data-q]"); if (!b) return; sel.qty = Math.max(1, Math.min(20, sel.qty + Number(b.dataset.q))); render(); });
    P("add").addEventListener("click", async () => {
      const v = current(); if (!v || !v.available) return;
      P("add").disabled = true;
      const ok = await addVariant(v.id, sel.qty, s.name);
      P("add").disabled = false;
      if (ok) { opts.onAdded?.(); setTimeout(openCart, opts.modal ? 450 : 200); }
    });
    return { open, nav: (d) => showMedia(sel.media + d), get scent() { return s; } };
  }

  // a product without story copy (zestaw, gift card…): Shopify images + one button row per option
  function mountGeneric(root, data) {
    const p = RJ.products[data.handle]; if (!p) return;
    const P = (k) => root.querySelector(`[data-pdp="${k}"]`);
    let v = p.variants.find((x) => x.id === data.selected) || p.variants[0], qty = 1, media = 0;
    ["forms-wrap", "colors-wrap", "tag", "line", "notes", "moments"].forEach((k) => P(k) && (P(k).hidden = true));
    const opt = document.createElement("div");
    opt.className = "pdp-opt generic";
    P("colors-wrap").after(opt);
    const show = (i) => {
      if (!data.images.length) return;
      media = (i + data.images.length) % data.images.length;
      P("main").innerHTML = `<img src="${data.images[media]}" alt="${p.title}">`;
      $$("button", P("thumbs")).forEach((b, j) => b.classList.toggle("on", j === media));
    };
    const render = () => {
      opt.innerHTML = p.options.map((name, oi) => `<p class="opt-label">${name}: <b>${v.options[oi]}</b></p><div class="opt-values">${[...new Set(p.variants.map((x) => x.options[oi]))].map((val) => `<button class="note${val === v.options[oi] ? " on" : ""}" data-oi="${oi}" data-val="${val.replace(/"/g, "&quot;")}">${val}</button>`).join("")}</div>`).join("");
      P("qty").textContent = qty;
      P("add").disabled = !v.available;
      P("add").textContent = v.available ? `${addLabel()} · ${money(v.price * qty)}` : "Chwilowo wyprzedane";
    };
    P("thumbs").innerHTML = data.images.map((src) => `<button><img src="${src}" alt="" loading="lazy"></button>`).join("");
    P("thumbs").addEventListener("click", (e) => { const b = e.target.closest("button"); if (b) show($$("button", P("thumbs")).indexOf(b)); });
    opt.addEventListener("click", (e) => {
      const b = e.target.closest("[data-oi]"); if (!b) return;
      const want = v.options.map((o, i) => (i === Number(b.dataset.oi) ? b.dataset.val : o));
      v = p.variants.find((x) => x.options.every((o, i) => o === want[i])) || p.variants.find((x) => x.options[b.dataset.oi] === b.dataset.val) || v;
      render();
    });
    $(".pdp-buy .qty", root).addEventListener("click", (e) => { const b = e.target.closest("[data-q]"); if (!b) return; qty = Math.max(1, Math.min(20, qty + Number(b.dataset.q))); render(); });
    P("add").addEventListener("click", async () => { if (v.available && (await addVariant(v.id, qty, p.title))) setTimeout(openCart, 200); });
    show(0); render();
  }

  // ---------- shared: dialog, overlays ----------
  const pdpEl = $("#pdp");
  const modal = pdpEl ? mountPdp($(".pdp-panel", pdpEl), { modal: true, onAdded: () => closeAll() }) : null;
  const openPdp = (slug) => {
    if (!modal || !bySlug[slug]) return;
    modal.open(slug);
    pdpEl.hidden = false; document.body.classList.add("locked");
    $(".pdp-info", pdpEl).scrollTop = 0;
    if (isHome) history.replaceState(null, "", `#zapach-${slug}`);
  };
  function closeAll() {
    [pdpEl, $("#cart"), $("#lightbox")].forEach((el) => { if (el) el.hidden = true; });
    if (pdpEl) $('[data-pdp="main"]', pdpEl).innerHTML = "";
    $("#lightboxVideo")?.pause();
    document.body.classList.remove("locked");
    if (location.hash.startsWith("#zapach-")) history.replaceState(null, "", location.pathname + location.search);
  }
  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-open]");
    if (o) { e.preventDefault(); openPdp(o.dataset.open); return; }
    if (e.target.closest("[data-close]")) closeAll();
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
    if (pdpEl && !pdpEl.hidden && (e.key === "ArrowRight" || e.key === "ArrowLeft")) modal.nav(e.key === "ArrowRight" ? 1 : -1);
    if (e.key === "Enter" && e.target.matches("[data-open]")) openPdp(e.target.dataset.open);
  });

  // ---------- sound: wood-wick crackle via WebAudio ----------
  const crackle = (() => {
    let ctx, master, on = false, timer;
    const init = () => {
      if (ctx) return;
      ctx = new (window.AudioContext || window.webkitAudioContext)();
      master = ctx.createGain(); master.gain.value = 0; master.connect(ctx.destination);
      const len = ctx.sampleRate * 4, buf = ctx.createBuffer(1, len, ctx.sampleRate), d = buf.getChannelData(0);
      let last = 0;
      for (let i = 0; i < len; i++) { last = (last + 0.02 * (Math.random() * 2 - 1)) / 1.02; d[i] = last * 3.2; }
      const bed = ctx.createBufferSource(); bed.buffer = buf; bed.loop = true;
      const lp = ctx.createBiquadFilter(); lp.type = "lowpass"; lp.frequency.value = 500;
      const g = ctx.createGain(); g.gain.value = 0.35;
      bed.connect(lp).connect(g).connect(master); bed.start();
    };
    const pop = (vol = 1) => {
      const dur = 0.004 + Math.random() * 0.02;
      const b = ctx.createBuffer(1, Math.ceil(ctx.sampleRate * dur), ctx.sampleRate), d = b.getChannelData(0);
      for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / d.length, 3);
      const src = ctx.createBufferSource(); src.buffer = b;
      const bp = ctx.createBiquadFilter(); bp.type = "bandpass"; bp.frequency.value = 1500 + Math.random() * 4000; bp.Q.value = 0.8;
      const g = ctx.createGain(); g.gain.value = (0.2 + Math.random() * 0.8) * vol;
      src.connect(bp).connect(g).connect(master); src.start();
    };
    const loop = () => {
      if (!on) return;
      pop();
      if (Math.random() < 0.25) setTimeout(() => on && pop(0.6), 30 + Math.random() * 60);
      timer = setTimeout(loop, 80 + Math.random() * (Math.random() < 0.3 ? 1400 : 420));
    };
    return {
      toggle(state) { init(); ctx.resume(); on = state; master.gain.setTargetAtTime(on ? 0.5 : 0, ctx.currentTime, 0.4); clearTimeout(timer); if (on) loop(); },
      burst() { if (soundOn) this.toggle(true); },
    };
  })();
  let soundOn = store.get("sound", false);
  const soundBtn = $("#soundBtn");
  const setSound = (v) => { soundOn = v; soundBtn.setAttribute("aria-pressed", String(v)); store.set("sound", v); crackle.toggle(v); };
  soundBtn?.addEventListener("click", () => setSound(!soundOn));
  if (soundOn && soundBtn) {
    soundBtn.setAttribute("aria-pressed", "true");
    window.addEventListener("pointerdown", () => crackle.toggle(true), { once: true });
  }

  // ---------- phone menu ----------
  const menuBtn = $("#menuBtn"), navMenu = $("#navMenu");
  const setMenu = (open) => {
    if (!navMenu) return;
    navMenu.hidden = !open;
    menuBtn.setAttribute("aria-expanded", String(open));
    document.body.classList.toggle("menu-open", open);
  };
  menuBtn?.addEventListener("click", () => setMenu(navMenu.hidden));
  navMenu?.addEventListener("click", (e) => {
    const a = e.target.closest("a"); if (!a) return;
    setMenu(false);
    // a link to a part of this page: close the menu first, then glide there
    const url = new URL(a.href, location.href), target = url.hash && url.pathname === location.pathname && $(url.hash);
    if (target) {
      e.preventDefault();
      setTimeout(() => target.scrollIntoView({ behavior: "smooth", block: "start" }), 30);
      // a browser that skips smooth scrolling still gets there
      setTimeout(() => { if (Math.abs(target.getBoundingClientRect().top) > 120) target.scrollIntoView(); }, 1200);
      history.replaceState(null, "", url.hash);
    }
  });
  addEventListener("keydown", (e) => { if (e.key === "Escape") setMenu(false); });

  // ---------- nav, cursor glow, reveal ----------
  const nav = $("#nav");
  const onScroll = () => nav?.classList.toggle("solid", scrollY > 40 || !isHome);
  addEventListener("scroll", onScroll, { passive: true }); onScroll();
  const glow = $(".cursor-glow");
  addEventListener("pointermove", (e) => {
    glow.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
    const el = document.elementFromPoint(e.clientX, e.clientY);
    document.body.classList.toggle("glow-on", !!el?.closest(".dark, .stories"));
  }, { passive: true });

  let toastT;
  function toast(msg) { const t = $("#toast"); if (!t) return; t.textContent = msg; t.classList.add("on"); clearTimeout(toastT); toastT = setTimeout(() => t.classList.remove("on"), 2600); }

  // collection card (homepage grid and "Poczuj też")
  const card = (s) => `
    <article class="card reveal" data-family="${s.family}" data-open="${s.slug}">
      <div class="card-img">
        <img src="${prodImg(s, "duza")}" alt="Świeca ${s.name}" loading="lazy">
        <img class="alt" src="${moodImg(s)}"${moodPos(s)} alt="" loading="lazy">
        ${s.limited ? `<span class="card-tag">Edycja limitowana</span>` : s.bestseller ? `<span class="card-tag">Bestseller</span>` : ""}
        <button class="card-quick" data-open="${s.slug}">${s.limited ? "Zobacz" : "Wybierz formę"}</button>
      </div>
      <div class="card-body">
        <h3>${s.product ? `<a href="${s.product.url}" data-open="${s.slug}">${s.name}</a>` : s.name}</h3>
        <p class="card-notes">${s.notes.join(" · ")}</p>
        <p class="card-price">${fromLabel(s)}</p>
      </div>
    </article>`;

  // ---------- product page ----------
  const pagePdp = $("#pagePdp");
  if (pagePdp) {
    const data = JSON.parse($("#rjCurrentProduct").textContent);
    const s = byHandle[data.handle];
    if (s) {
      // preselect the variant from the URL (?variant=…)
      const v = s.product.variants.find((x) => x.id === data.selected);
      let pre = null;
      if (v) {
        const vals = v.options.map(norm);
        const formKey = vals.some((o) => o.startsWith("ELLIPSA")) ? "ellipsa" : "tunel";
        const fi = formsOf(s).findIndex((f) => f.key === formKey), ci = colorIndexOf(v.options);
        if (fi >= 0 && ci >= 0) pre = { form: fi, color: ci };
      }
      mountPdp(pagePdp).open(s.slug, new URLSearchParams(location.search).has("variant") ? pre : null);
    } else {
      mountGeneric(pagePdp, data);
    }
    const also = $("#alsoGrid");
    if (also) {
      const pool = SCENTS_LIVE.filter((x) => !x.limited && x.handle !== data.handle);
      const same = s ? pool.filter((x) => x.family === s.family) : [];
      also.innerHTML = [...same, ...pool.filter((x) => !same.includes(x))].slice(0, 4).map(card).join("");
    }
  }

  // ---------- homepage ----------
  if (isHome) home();

  // reveal on scroll (after the homepage / product page has built its lists)
  const ignitePending = !!$("#ignite");
  const rio = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); rio.unobserve(e.target); } }), { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
  $$(".reveal").forEach((el) => { if (!el.closest(".hero") || !ignitePending) rio.observe(el); });

  function home() {
    // intro: light the candle
    const ignite = $("#ignite");
    const revealHero = () => { $(".arch video")?.play().catch(() => {}); $$(".hero .reveal").forEach((el, i) => setTimeout(() => el.classList.add("in"), i * 140)); };
    let alreadyLit = false;
    try { alreadyLit = sessionStorage.getItem("lit") === "1" || /customer_posted|#zapach-/.test(location.href); } catch {}
    if (ignite) {
      if (alreadyLit) { ignite.remove(); } else { document.body.classList.add("locked"); }
      const lightUp = () => {
        if (ignite.classList.contains("lit")) return;
        ignite.classList.add("lit"); crackle.burst();
        setTimeout(() => ignite.classList.add("gone"), 50);
        setTimeout(() => { document.body.classList.remove("locked"); ignite.remove(); revealHero(); }, 2800);
        try { sessionStorage.setItem("lit", "1"); } catch {}
      };
      $("#igniteBtn")?.addEventListener("click", lightUp);
      $("#igniteCta")?.addEventListener("click", lightUp);
      $("#igniteSkip")?.addEventListener("click", () => {
        ignite.classList.add("lit", "gone");
        setTimeout(() => { document.body.classList.remove("locked"); ignite.remove(); revealHero(); }, 900);
        try { sessionStorage.setItem("lit", "1"); } catch {}
      });
    }

    // memory text: words light up while scrolling
    const mem = $("#memoryText");
    if (mem) {
      const hot = ["furtką,", "wspomnienia.", "najlepiej."];
      mem.innerHTML = mem.textContent.trim().split(/\s+/).map((w) => `<span class="w${hot.includes(w) ? " hot" : ""}">${w}</span>`).join(" ");
      const words = $$(".w", mem);
      const memScroll = () => {
        const r = mem.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, (innerHeight * 0.85 - r.top) / (r.height + innerHeight * 0.35)));
        const n = Math.round(p * words.length);
        words.forEach((w, i) => w.classList.toggle("on", i < n));
      };
      addEventListener("scroll", memScroll, { passive: true }); memScroll();
    }

    // mood finder
    const chips = $("#moodChips"), result = $("#moodResult");
    const moods = MOODS.map((m) => ({ ...m, picks: m.picks.filter((p) => bySlug[p]) })).filter((m) => m.picks.length);
    chips.innerHTML = moods.map((m, i) => `<button class="chip" role="tab" aria-selected="${i === 0}" data-mood="${m.key}">${m.label}</button>`).join("");
    const renderMood = (key) => {
      const m = moods.find((x) => x.key === key);
      const [a, ...rest] = m.picks.map((p) => bySlug[p]);
      const tile = (s, main) => `
        <article class="${main ? "mood-main" : "mood-alt"}" data-open="${s.slug}" tabindex="0">
          <img src="${moodImg(s)}"${moodPos(s)} alt="Świeca ${s.name}" loading="lazy">
          ${main ? `<span class="best">Najlepiej pasuje</span>` : ""}
          <div class="mood-copy">
            <p class="kicker">${s.tagline}</p>
            <h3>${s.name}</h3>
            <p>${s.line}</p>
            <div class="mood-meta">${main ? `<span class="btn btn-ember">Chcę ją</span>` : ""}<span>${s.notes.join(" · ")}</span><span>${fromLabel(s)}</span></div>
          </div>
        </article>`;
      result.innerHTML = `<p class="mood-line">${m.line}</p><div class="mood-grid fade-swap">${tile(a, true)}${rest.map((s) => tile(s, false)).join("")}</div>`;
    };
    chips.addEventListener("click", (e) => {
      const b = e.target.closest(".chip"); if (!b) return;
      $$(".chip", chips).forEach((c) => c.setAttribute("aria-selected", String(c === b)));
      renderMood(b.dataset.mood);
    });
    if (moods.length) renderMood(moods[0].key);

    // story chapters
    const FEATURED = ["konwaliowe-pole", "letnie-noce", "wedrowka", "noc-swietojanska", "puls", "przytulisko"].filter((x) => bySlug[x]);
    $("#historie").innerHTML = FEATURED.map((slug, i) => {
      const s = bySlug[slug];
      return `
        <article class="story" style="--a:${s.accent}">
          <div class="story-media reveal">
            <img class="big" src="${lifeImg(s, 1)}" alt="Świeca ${s.name}" loading="lazy">
            <img class="small parallax" data-speed="0.08" src="${lifeImg(s, s.life >= 3 ? 3 : 2)}" alt="" loading="lazy">
          </div>
          <div class="story-text reveal">
            <span class="story-num">0${i + 1} / 0${FEATURED.length}</span>
            <span class="story-tag">${s.tagline}</span>
            <h2>${s.name}</h2>
            <p class="story-line">${s.line}</p>
            <div class="notes">${s.notes.map((n) => `<span class="note">${n}</span>`).join("")}</div>
            <div class="story-buy">
              <button class="btn btn-ember" data-open="${s.slug}">Poczuj ją</button>
              <span class="from">${fromPrice(s) != null ? `od<b>${money(fromPrice(s))}</b>` : ""}</span>
            </div>
          </div>
        </article>`;
    }).join("");
    // landscape secondary photos get a landscape frame so nothing important is cropped away
    $$(".story-media .small").forEach((img) => {
      const fit = () => img.classList.toggle("wide", img.naturalWidth > img.naturalHeight);
      img.complete ? fit() : img.addEventListener("load", fit, { once: true });
    });
    const pars = $$(".parallax");
    const parScroll = () => pars.forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      el.style.transform = `translateY(${(r.top + r.height / 2 - innerHeight / 2) * -Number(el.dataset.speed)}px)`;
    });
    if (!matchMedia("(prefers-reduced-motion: reduce)").matches) { addEventListener("scroll", parScroll, { passive: true }); parScroll(); }

    // collection grid + filters
    const filters = $("#filters"), grid = $("#grid");
    const fams = Object.entries(FAMILIES).filter(([k]) => SCENTS_LIVE.some((s) => s.family === k));
    filters.innerHTML = [`<button class="filter" aria-pressed="true" data-f="all">Wszystkie</button>`, ...fams.map(([k, v]) => `<button class="filter" aria-pressed="false" data-f="${k}">${v}</button>`)].join("");
    grid.innerHTML = SCENTS_LIVE.map(card).join("");
    filters.addEventListener("click", (e) => {
      const b = e.target.closest(".filter"); if (!b) return;
      $$(".filter", filters).forEach((f) => f.setAttribute("aria-pressed", String(f === b)));
      $$(".card", grid).forEach((c) => c.classList.toggle("hide", b.dataset.f !== "all" && c.dataset.family !== b.dataset.f));
    });

    // the three forms with live prices; the zestaw card only when the zestaw product exists
    const sizes = $("#formSizes");
    if (sizes) {
      const minOf = (k) => { const ps = SCENTS_LIVE.flatMap((s) => COLORS.map((_, ci) => variantFor(s, k, ci))).filter(Boolean).map((v) => v.price); return ps.length ? Math.min(...ps) : null; };
      const t = minOf("tunel"), e = minOf("ellipsa"), z = minOf("zestaw");
      if (t != null) $('[data-form="tunel"] [data-price]', sizes).textContent = money(t);
      if (e != null) $('[data-form="ellipsa"] [data-price]', sizes).textContent = money(e);
      const zc = $('[data-form="zestaw"]', sizes);
      if (z != null && zc) {
        zc.hidden = false;
        $("[data-price]", zc).innerHTML = t && 2 * t > z ? `<s>${money(2 * t)}</s> ${money(z)}` : money(z);
        if (t && 2 * t > z) $("[data-save]", zc).textContent = `−${money(2 * t - z)}`; else $("[data-save]", zc).remove();
      }
    }

    // films: the "logo wave"
    reelsWave();

    // production film
    $("#prodBtn")?.addEventListener("click", (e) => {
      const lb = $("#lightbox"), v = $("#lightboxVideo");
      v.src = e.currentTarget.dataset.src; v.poster = e.currentTarget.dataset.poster;
      lb.hidden = false; document.body.classList.add("locked"); v.play().catch(() => {});
    });

    // autoplay inline videos only while visible
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { v.preload = "auto"; v.play().catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.35 });
    $$("video[data-autoplay]").forEach((v) => vio.observe(v));

    if (location.hash.startsWith("#zapach-") && bySlug[location.hash.slice(8)]) openPdp(location.hash.slice(8));
  }

  // Every reel ends on the Rozpal Ją logo on black. The reels on screen are started so they end one after
  // another from left to right, and the logo seems to flow across the strip. Ended reels hold the logo frame;
  // when the whole wave has finished, it starts again. A reel the visitor unmutes leaves the wave and loops.
  function reelsWave() {
    const REEL_ORDER = ["puls", "konwaliowe-pole", "letnie-noce", "rausz", "jutrznia", "noc-swietojanska", "przytulisko", "igrzyska", "porcelana", "wedrowka", "julia", "siedlisko", "randezvous", "przedwiosnie", "jutro", "boskosc"].filter((x) => bySlug[x]);
    const track = $("#reelTrack");
    track.innerHTML = REEL_ORDER.map((slug) => {
      const s = bySlug[slug];
      return `
        <div class="reel">
          <div class="reel-frame"><video src="${video(s)}" poster="${poster(s)}" muted playsinline preload="metadata"></video><span class="snd">🔇</span></div>
          <div class="reel-foot"><h3>${s.name}</h3><button data-open="${s.slug}">${s.limited ? "Zobacz" : "Kup"}</button></div>
        </div>`;
    }).join("");
    const reels = $$("video", track);
    const WAVE_STEP = 0.8, WAVE_MAX = 18, WAVE_PAUSE = 2500;
    let solo = null, waveOn = false, waveTimer, waveId = 0;
    const ready = (v) => (v.readyState >= 1 ? Promise.resolve() : new Promise((r) => v.addEventListener("loadedmetadata", r, { once: true })));
    const onScreen = () => {
      const box = track.getBoundingClientRect();
      return reels.filter((v) => { const r = v.getBoundingClientRect(); return Math.min(r.right, box.right) - Math.max(r.left, box.left) > r.width * 0.5; });
    };
    async function startWave() {
      clearTimeout(waveTimer);
      const id = ++waveId;
      const vis = onScreen().filter((v) => v !== solo);
      reels.forEach((v) => { if (v !== solo && !vis.includes(v)) v.pause(); });
      if (!waveOn || !vis.length) return;
      await Promise.all(vis.map(ready));
      if (id !== waveId) return;
      const lead = Math.min(WAVE_MAX, ...vis.map((v, i) => v.duration - i * WAVE_STEP));
      let left = vis.length;
      vis.forEach((v, i) => {
        v.currentTime = Math.max(0, v.duration - (lead + i * WAVE_STEP));
        v.onended = () => { if (id === waveId && --left === 0) waveTimer = setTimeout(startWave, WAVE_PAUSE); };
        v.play().catch(() => {});
      });
    }
    new IntersectionObserver(([e]) => { waveOn = e.isIntersecting; startWave(); }, { threshold: 0.3 }).observe(track);
    let scrollT;
    track.addEventListener("scroll", () => { clearTimeout(scrollT); scrollT = setTimeout(startWave, 350); }, { passive: true });
    addEventListener("resize", () => { clearTimeout(scrollT); scrollT = setTimeout(startWave, 350); });
    track.addEventListener("click", (e) => {
      const f = e.target.closest(".reel-frame"); if (!f) return;
      const v = $("video", f), turnOn = v !== solo;
      if (solo) { solo.muted = true; solo.loop = false; solo.nextElementSibling.textContent = "🔇"; solo = null; }
      if (turnOn) { solo = v; v.onended = null; v.muted = false; v.loop = true; v.currentTime = 0; v.play(); f.querySelector(".snd").textContent = "🔊"; }
      startWave();
    });
  }
})();
